{
  "FileUpload_DragAndDrop": "Solte o arquivo aqui ou clique para selecionar o arquivo",
  "FileUpload_DropFileHere": "Solte o arquivo aqui",
  "FileUpload_Accepted": "O arquivo será aceito",
  "FileUpload_Rejected": "O arquivo será rejeitado",
  "FileUpload_SelectedFile": "Arquivo selecionado: {}",
  "FileUpload_Validation_OverMaxSize": "O tamanho do arquivo excede o tamanho máximo permitido de {}",
  "FileUpload_Validation_MaxDimensions": "As dimensões do arquivo excedem as dimensões máximas permitidas de {}x{}",
  "FileUpload_Validation_MinDimensions": "As dimensões do arquivo estão abaixo das dimensões mínimas permitidas de {}x{}",
  "FileUpload_Validation_NotTransparent": "O fundo do arquivo não é transparente",
  "NAME": "FileUploadLanguage"
}